export function getCopyright(): string {
  return '2023. Gelin';
}
